import React from "react";
import { Doughnut } from "react-chartjs-2";

import { ArcElement, Chart, ChartData, ChartOptions, Legend, Tooltip } from "chart.js";

import { Icon } from "components";

Chart.register(ArcElement, Legend, Tooltip);

type ResilienceScoreDonutChartProps = {
  progressPct: number;
  color?: string;
};

const COLORS = {
  yellow: "#ecf86e",
  grey: "#e8e8e8",
};

const ResilienceScoreDonutChart = ({ progressPct, color = COLORS.yellow }: ResilienceScoreDonutChartProps) => {
  const clampedProgress = Math.max(0, Math.min(progressPct, 10));
  const data: ChartData<"doughnut"> = {
    datasets: [
      {
        data: [clampedProgress, 10 - clampedProgress],
        backgroundColor: [color, COLORS.grey],
        borderWidth: 0,
      },
    ],
  };

  const options: ChartOptions<"doughnut"> = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    cutout: "68%",
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
      datalabels: {
        display: false,
      },
    },
  };
  return (
    <div className="rsd-donut" data-testid="resilience-score-donut">
      <Doughnut className="rsd-donut-canvas" data={data} options={options} />
      <Icon iconName="klim/plant" size="m-light" className="rsd-donut-icon" />
    </div>
  );
};

export default ResilienceScoreDonutChart;
